<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="my-thoughts-and-reactions">
<h1>My Thoughts and Reactions</h1>
<p style="padding-left:17px">___________________________________________________________</p>
<p>___________________________________________________________</p>
<p>___________________________________________________________</p>
<p>___________________________________________________________</p>
<p>___________________________________________________________</p>
<p>___________________________________________________________</p>
<p>___________________________________________________________</p>
<p>___________________________________________________________</p>
<p>___________________________________________________________</p>
<p>___________________________________________________________</p>
<p>___________________________________________________________</p>
<p>___________________________________________________________</p>
<p>___________________________________________________________</p>
<p>___________________________________________________________</p>
<p>___________________________________________________________</p>
<p>___________________________________________________________</p>
<p>___________________________________________________________</p>
<p>___________________________________________________________</p>
<p>___________________________________________________________</p>
<p>___________________________________________________________</p>
<p>___________________________________________________________</p>
<p>___________________________________________________________</p>
<p>___________________________________________________________</p>
<p>___________________________________________________________</p>
<p>___________________________________________________________</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch007.vue?56dc34d2